var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoR1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 200,
    viewBox: "0 0 116 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.8643 52.0078L91.8311 52.1865L91.9199 52.3438C94.9552 57.7403 100.745 62.0816 105.716 65.0586C108.21 66.5523 110.517 67.7133 112.2 68.501C112.93 68.8424 113.544 69.1122 114.005 69.3105L57.7529 101.323L57.7441 101.328C54.671 103.165 52.9484 106.287 51.9824 109.333C51.0151 112.384 50.785 115.421 50.7412 117.183V117.184L48.8184 198.967L16.9824 178.632L16.9746 178.627L16.502 178.333C6.8093 172.179 0.71671 161.13 0.505859 149.249L0.5 148.674V75.8701C0.500113 65.3759 5.93872 55.6788 14.7158 50.5684L101.298 0.969727L91.8643 52.0078Z",
    stroke: "#434D91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoR1);
export default __webpack_public_path__ + "static/media/logo-r-1.d756352704a56cb93469e0830adcd723.svg";
export { ForwardRef as ReactComponent };